import React, { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../logo512.png";
import { useTranslation } from "react-i18next";
import "../i18n";
import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";

function Logout() {
    const { logout } = useContext(AuthContext);
  const { auth } = useContext(AuthContext); // Access the auth state
  // const { login } = useContext(AuthContext);
  // const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const response = await fetch(baseUrl + "v1/login/", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ username, password }),
  //   });
  //   const data = await response.json();
  //   if (response.ok) {
  //     login(data.access, data.refresh, data.username, data.role);
  //   //   localStorage.setItem('access', data.access);
  //   //   localStorage.setItem('refresh', data.refresh);
  //   //   localStorage.setItem('username', data.username);
  //   //   localStorage.setItem('userrole', data.role);
  //     console.log(
  //       "data: ",
  //       data.username,
  //       data.role,
  //       data.access,
  //       data.refresh
  //     );
  //     console.log("Sukses: ", username);
  //     console.log("auth.accessToken: vanuit Login", auth.accessToken);
  //     navigate(-1)
  //   } else {
  //     console.error("Login failed");
  //   }
  // };


  
  // const handleKeyDown = (event) => {
  //   if (event.key === "Enter") {
  //     handleSubmit(event);
  //   }
  // };

  // useEffect(() => {
  //   const fetchUserRole = async () => {
  //     if (auth?.accessToken) {
  //       const response = await fetch(baseUrl + 'v1/user-role/', {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: `Bearer ${auth.accessToken}`,
  //         },
  //       });
  //       const data = await response.json();
  //       setUserRole(data.role);
  //       console.log("setUserRole in fetchUserRole", data.role)
  //     }
  //   };

  //   fetchUserRole();
  // }, [auth]);
  // Claude: bugfix reported directly — "sometimes when logging out... the page does not refresh...
  // a blank page is displayed." Two independent bugs. (1) the Confirm log out button below had an
  // invalid type="logout" — HTML defaults an unrecognized button type to "submit", so clicking it
  // also triggered the wrapping <form>'s native submission (a full-page reload of the current URL)
  // racing with React's own state update, alongside the onClick handler — same class of bug as the
  // AddWord.js fix elsewhere in this codebase. (2) landing here already logged out (a stale
  // bookmark, or that native reload) called navigate(-2) — an arbitrary "go back two history
  // entries" that can land anywhere depending on how the user got here, not a fixed destination.
  // Both are replaced with a single, deterministic redirect to the landing page, per explicit
  // instruction ("go to the standard landing page (search) whenever somebody logs out").
  //
  // Reads localStorage directly rather than auth?.accessToken — AuthContext's own hydration-from-
  // localStorage effect (AuthContext.js) runs on this same mount, but child effects (this one) fire
  // before parent effects, so auth would still be its unhydrated initial null on this first pass
  // even for a genuinely logged-in visitor. localStorage has no such lag.
  useEffect(() => {
    if (!localStorage.getItem('accessToken')) {
      navigate("/");
    }
  }, [navigate]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // Claude: alpha-tester feedback — "The Log out page has only 'Confirm log out', with no Cancel or
  // Claude: Back button." Cancel returns to wherever the user came from; if this page was opened
  // Claude: directly (React Router v6 gives the very first entry of a session location.key
  // Claude: "default"), go to the landing page instead of navigating back out of the site.
  const handleCancel = () => {
    if (location.key !== "default") {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* <Navbar /> */}
      {/* <div> */}
      {/* {auth.userRole === "editor" && <Navbar />}
      {auth.userRole !== "editor" && <Navbaranonuser />} */}
      {localStorage.setItem("bladsy", "Logout")}
      {auth.userName === null && <Navbaranonuser />}
      {auth.userName != null && <Navbar />}      
      {/* </div> */}
      

      <div className="flex flex-col justify-center items-center p-2">
        <h1 className="text-4xl font-bold mb-6">
          <Link to={"/"}>
            {/* <a href="/" className="inline-block">  */}
            {t("logout")}
            {/* </a> */}
          </Link>
        </h1>
        <div className="w-full max-w-3xl bg-white rounded-lg shadow-lg p-3">

        <button
          onClick={handleLogout}
          type="button"
          className="w-full bg-cyan-700 text-white py-2 mb-4 mt-4 px-4 rounded-lg hover:bg-cyan-800"
        >
          {t("confirmlogout")}
        </button>
        <button
          onClick={handleCancel}
          type="button"
          className="w-full bg-gray-500 text-white py-2 mb-4 px-4 rounded-lg hover:bg-gray-600"
        >
          {t("cancel")}
        </button>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center p-4 mt-8">
        <Link to={"/"}>
          <img src={Logo} alt="Logo" width="100" height="100" />
        </Link>
      </div>
    </div>
  );
}

export default Logout;
